/** aigc-web 专用 localStorage 键名（最终为 yt_${key}，与 client 的 yt_userInfo 等隔离） */
export const storagekeys = {
  userInfo: 'aigc_web_userInfo',
  currentLang: 'aigc_web_currentLang',
  currentSessionId: 'aigc_web_currentSessionId'
}
